import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TempLaminationService{
  // private apiUrl = "http://localhost:3003/api/tempLamination";
   private apiUrl = "https://lexipackghana.com:3003/api/tempLamination";

  constructor(private http: HttpClient) {}
  addTempLamination(data:any){
    return this.http.post(this.apiUrl+'/addTempLamination',data);
  }
  getTempLamination(){
    return this.http.get(this.apiUrl+'/getAllTempLamination');
  }
  getTempLaminationById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateTempLamination(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }
}
